import { useLoggedInUser } from "hooks/useLoggedInUser";

import { GuestLayout } from "./GuestLayout";
import { LoggedLayout } from "./LoggedLayout";

export const Layout = () => {
  const { isLoggedIn } = useLoggedInUser();
  return isLoggedIn ? <LoggedLayout /> : <GuestLayout />;
};
